module.exports = __webpack_public_path__ + "img/45_23.584b6ba5.png";